import './styles/App.css';
import { useEffect } from 'react';
import useAuthStore from './stores/authStore';
import LoginScreen from './screens/Login/LoginScreen.jsx';
import HomeScreen from './screens/Home/HomeScreen.jsx';
import { Routes, Route } from 'react-router-dom';
import PrivateRoutes from './utils/PrivateRoutes.jsx';
import PublicRoutes from './utils/PublicRoutes.jsx';
import Loader from './components/Loader/Loader.jsx';
import Navbar from './components/Navbar/Navbar.jsx';
import ProductKeywordScreen from './screens/Product/Keyword/ProductKeywordScreen.jsx';
import ProductGeneratedScreen from './screens/Product/Generated/ProductGeneratedScreen.jsx';
import ArticleIdeasScreen from './screens/Article/Ideas/ArticleIdeasScreen.jsx';
import LegalFormScreen from './screens/Terms/Legal/Form/LegalFormScreen.jsx';
import LegalGeneratedScreen from './screens/Terms/Legal/Generated/LegalGeneratedScreen.jsx';
import CGVFormScreen from './screens/Terms/CGV/Form/CGVFormScreen.jsx';
import CGVGeneratedScreen from './screens/Terms/CGV/Generated/CGVGeneratedScreen.jsx';
import PPFormScreen from './screens/Terms/PP/Form/PPFormScreen.jsx';
import PPGeneratedScreen from './screens/Terms/PP/Generated/PPGeneratedScreen.jsx';
import RRPFormScreen from './screens/Terms/RRP/Form/RRPFormScreen.jsx';
import RRPGeneratedScreen from './screens/Terms/RRP/Generated/RRPGeneratedScreen.jsx';
import PricingScreen from './screens/Pricing/PricingScreen.jsx';
import PricingSuccessScreen from './screens/Pricing/PricingSuccessScreen.jsx';
import SubscriptionsScreen from './screens/User/Subscriptions/SubscriptionsScreen.jsx';
import TermsScreen from './screens/Terms/Index/IndexScreen.jsx';
import useSubscriptionListener from './hooks/useSubscriptionListener.js';
import useSubscriptionStore from './stores/subscriptionStore.js';
import useUsageListener from './hooks/useUsageListener';
import useUsageStore from './stores/usageStore.js';
import useProductListener from './hooks/useProductListener.js';
import useProductStore from './stores/productStore.js';
import RegisterScreen from './screens/Register/RegisterScreen.jsx';
import ArticleScreen from './screens/Article/Index/IndexScreen.jsx';
import ArticleIdeasGeneratedScreen from './screens/Article/IdeasGenerated/ArticleIdeasGeneratedScreen.jsx';
import ArticleGeneratedScreen from './screens/Article/Generated/ArticleGeneratedScreen.jsx';
import ArticleGeneratorScreen from './screens/Article/Generator/ArticleGeneratorScreen.jsx';
import PasswordForgotScreen from './screens/Password/Forgot/PasswordForgot.jsx';
import ImageScreen from './screens/Image/Index/IndexScreen.jsx';
import ImageAltScreen from './screens/Image/Alt/ImageAltScreen.jsx';
import AffiliationsScreen from './screens/User/Affiliations/AffiliationsScreen.jsx';
import useUserListener from './hooks/useUserListener.js';

function App() {
  const { user, init, isLoading } = useAuthStore();
  useProductListener();
  useSubscriptionListener();
  useUsageListener();
  useUserListener();
  const { isLoading: isProductLoading } = useProductStore();
  const { isLoading: isSubscriptionLoading } = useSubscriptionStore();
  const { isLoading: isUsageLoading } = useUsageStore();

  useEffect(() => {
    init();
  }, [init]);

  if (
    (isLoading && isProductLoading) ||
    (user && user.emailVerified && (isSubscriptionLoading || isUsageLoading))
  ) {
    return <Loader className="min-h-inherit" />;
  }

  return (
    <>
      <Navbar />
      <Routes>

        <Route element={<PublicRoutes />}>
          <Route path="/login" element={<LoginScreen />} />
          <Route path="/register" element={<RegisterScreen />} />
          <Route path="/password/forgot" element={<PasswordForgotScreen />} />
        </Route>

        <Route element={<PrivateRoutes />}>
          <Route path="/" element={<HomeScreen />} />
          <Route path="/image" element={<ImageScreen />} />
          <Route path="/image/alt" element={<ImageAltScreen />} />
          <Route path="/product" element={<ProductKeywordScreen />} />
          <Route path="/product/generated" element={<ProductGeneratedScreen />} />
          <Route path="/article" element={<ArticleScreen />} />
          <Route path="/article/generator" element={<ArticleGeneratorScreen />} />
          <Route path="/article/ideas" element={<ArticleIdeasScreen />} />
          <Route path="/article/ideas/generated" element={<ArticleIdeasGeneratedScreen />} />
          <Route path="/article/generated" element={<ArticleGeneratedScreen />} />
          <Route path="/terms" element={<TermsScreen />} />
          <Route path="/terms/legal" element={<LegalFormScreen />} />
          <Route path="/terms/legal/generated" element={<LegalGeneratedScreen />} />
          <Route path="/terms/cgv" element={<CGVFormScreen />} />
          <Route path="/terms/cgv/generated" element={<CGVGeneratedScreen />} />
          <Route path="/terms/pp" element={<PPFormScreen />} />
          <Route path="/terms/pp/generated" element={<PPGeneratedScreen />} />
          <Route path="/terms/rrp" element={<RRPFormScreen />} />
          <Route path="/terms/rrp/generated" element={<RRPGeneratedScreen />} />
          <Route path="/user/subscriptions" element={<SubscriptionsScreen />} />
          <Route path="/user/affiliations" element={<AffiliationsScreen />} />
          <Route path="/pricing/success" element={<PricingSuccessScreen />} />
        </Route>

        <Route path="/pricing" element={<PricingScreen />} />

      </Routes>
    </>
  )
}

export default App;
